export function formatParado(segundos: number | null): string {
  if (segundos == null) return "—";
  const m = Math.floor(segundos / 60);
  const s = segundos % 60;
  if (m >= 60) {
    const h = Math.floor(m / 60);
    const rm = m % 60;
    return `${h}h ${rm}min`;
  }
  return `${m}min ${String(s).padStart(2, "0")}s`;
}

export function formatChegouHorario(createdAt?: string | null): string {
  if (!createdAt) return "—";
  const value = String(createdAt);
  const hasExplicitTimezone = /Z$|[+-]\d{2}:\d{2}$/.test(value);
  const normalizedUtcValue = hasExplicitTimezone
    ? value
    : `${value.replace(" ", "T").replace(/Z$/i, "")}Z`;
  const date = new Date(normalizedUtcValue);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleTimeString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function segundosToHHMMSS(segundos: number): string {
  if (!Number.isFinite(segundos) || segundos <= 0) return "00:00:00";
  const horas = Math.floor(segundos / 3600);
  const minutos = Math.floor((segundos % 3600) / 60);
  const secs = Math.floor(segundos % 60);
  return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

export function hhmmssToSegundos(value: string): number {
  const parts = value.split(":").map((p) => parseInt(p, 10));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return 0;
  return parts[0] * 3600 + parts[1] * 60 + parts[2];
}
